import dayjs from "dayjs";
import { useTranslations } from "use-intl";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { supplierFerryDatesQuery } from "@/app/Suppliers/GraphQL/supplierFerryDatesQuery";
import { SettingCard } from "@/app/Settings/Settings/Components/SettingFormCard";
import { Badge } from "@/components/catalyst/badge";

export function SupplierFerryDatesCard({ supplierId }: { supplierId: string }) {
  const t = useTranslations("settings.activeLines.ferryDates");
  const { data } = useSuspenseGqlQuery(supplierFerryDatesQuery, {
    id: supplierId,
  });

  const ferryDates = data.supplier.ferryDates;

  if (ferryDates.length === 0) {
    return (
      <SettingCard title={t("title")} description={t("emptyDescription")}>
        {null}
      </SettingCard>
    );
  }

  return (
    <SettingCard
      title={t("title")}
      description={t("description", {
        receivedAt: dayjs(ferryDates[0].created_at).format("D MMM YYYY h:mma"),
      })}
    >
      <div className="flex flex-wrap gap-2">
        {ferryDates.map((ferryDate) => (
          <Badge
            key={ferryDate.id}
            color={
              dayjs(ferryDate.sailing_date).isBefore(dayjs(), "day")
                ? "zinc"
                : "green"
            }
          >
            {dayjs(ferryDate.sailing_date).format("ddd D MMM")}
          </Badge>
        ))}
      </div>
    </SettingCard>
  );
}
